import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { IconComponent, KnowledgeBasePopOver, icon, I18nTranslate } from "../../../../../../../common/components";
import { translate } from "../../../../../../../common/providers";
import { isNonEmptyArray } from "../../../../../../../common/utils";
import PackageCard from "./PackageCard";
import styles from "./PackageSelection.module.css";

export default function PackageSelection({ selectedPackage, onSelectPackage }) {
	const packages = useSelector(({ newProject }) => newProject.packages);

	useEffect(() => {
		if (isNonEmptyArray(packages) && !selectedPackage) {
			if (packages.length === 1 && packages[0].isAuthorized !== false) {
				onSelectPackage(packages[0]);
			} else {
				const firstSelectablePackage = packages.find((pkg) => pkg.isAuthorized !== false);
				if (firstSelectablePackage) {
					onSelectPackage(firstSelectablePackage);
				}
			}
		}
	}, [packages, selectedPackage, onSelectPackage]);

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<span className={styles.title}>{translate("dashboards.new-project.package-selection.title")}</span>
				<IconComponent
					className={styles.requiredIcon}
					color="var(--red-500)"
					icon={icon.faAsterisk}
					size="2xs"
				/>
				<KnowledgeBasePopOver
					color="var(--grey-500)"
					label={<I18nTranslate translationKey="dashboards.new-project.package-selection.tooltip" />}
					size="2xs"
				/>
			</div>
			{!isNonEmptyArray(packages) || !packages.some((pkg) => pkg.isAuthorized !== false) ? (
				<div className={styles.emptyState}>
					{translate("dashboards.new-project.package-selection.empty-state")}
				</div>
			) : (
				<div className={styles.grid}>
					{packages.map((pkg) => (
						<PackageCard
							key={pkg.id}
							disabled={packages.length > 1 && pkg.isAuthorized === false}
							pkg={pkg}
							selected={selectedPackage?.id === pkg.id}
							onSelect={onSelectPackage}
						/>
					))}
				</div>
			)}
		</div>
	);
}

PackageSelection.propTypes = {
	selectedPackage: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
	}),
	onSelectPackage: PropTypes.func.isRequired,
};

PackageSelection.defaultProps = {
	selectedPackage: null,
};
